import React from 'react';
import { useUpload } from '../contexts/UploadContext';
import { useAuth } from '../contexts/AuthContext';
import { CloseIcon } from './Icons';

const UploadProgressBar: React.FC = () => {
    const { activeUpload, activeGeneration, cancelUpload, cancelGeneration, clearUpload } = useUpload();
    const { currentUser, usersData } = useAuth();

    if (!activeUpload && !activeGeneration) return null;

    const themeColor = usersData[currentUser]?.themeColor || '#2563eb';
    
    const isGeneration = !!activeGeneration;
    const activeTask = isGeneration ? activeGeneration : activeUpload;
    const { progress, status, error } = activeTask as any;
    const fileName = activeUpload ? activeUpload.fileName : (activeGeneration ? activeGeneration.postTitle : '');

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[100] bg-black/80 backdrop-blur-md border-t border-white/10 safe-area-bottom">
            <div className="flex items-center justify-between px-4 py-3 gap-4">
                <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                        <span className="text-xs font-medium text-white/70 truncate">
                            {status === 'uploading' && `Uploading ${fileName}...`}
                            {status === 'generating' && `Generating goodness...`}
                            {status === 'completed' && (isGeneration ? 'Ready! Check share sheet.' : 'Upload complete!')}
                            {status === 'error' && `${isGeneration ? 'Generation' : 'Upload'} failed: ${error}`}
                            {status === 'cancelled' && `${isGeneration ? 'Generation' : 'Upload'} cancelled`}
                        </span>
                        <span className="text-xs font-bold text-white shrink-0">
                            {(status === 'uploading' || status === 'generating') ? `${Math.round(progress)}%` : ''}
                        </span>
                    </div>
                </div>

                {(status === 'uploading' || status === 'generating') && (
                    <button
                        onClick={isGeneration ? cancelGeneration : cancelUpload}
                        className="p-1 hover:bg-white/10 rounded-full transition-colors text-white/70 hover:text-white"
                        title="Cancel"
                    >
                        <CloseIcon className="w-5 h-5" />
                    </button>
                )}

                {(status === 'error' || status === 'completed') && (
                    <button
                        onClick={clearUpload}
                        className="p-1 hover:bg-white/10 rounded-full transition-colors text-white/50"
                    >
                        <CloseIcon className="w-4 h-4" />
                    </button>
                )}
            </div>

            {/* The progress bar line itself */}
            <div className="h-1 w-full bg-white/10 overflow-hidden">
                <div
                    className="h-full transition-all duration-300 ease-out"
                    style={{
                        width: `${progress}%`,
                        backgroundColor: status === 'error' ? '#ef4444' : themeColor,
                        boxShadow: `0 0 8px ${status === 'error' ? '#ef4444' : themeColor}`
                    }}
                />
            </div>
        </div>
    );
};

export default UploadProgressBar;
